




import {Vue, Component} from 'vue-property-decorator'

import Library from '@/components/Library.vue'

@Component({
  components: {
      Library
  }
})
export default class LibraryView extends Vue {

}
